module.exports = __webpack_public_path__ + "static/ajinomoto-5706052c62973c4d63bc4ba23594b802.png";